import React from 'react';
import ContentLoader from 'react-content-loader';
var ItemSkeletonDesk = function ItemSkeletonDesk() {
  var skeletons = [];
  for (var index = 0; index < 12; index++) {
    skeletons.push(/*#__PURE__*/React.createElement(ContentLoader, {
      key: index,
      speed: 8,
      width: 1120,
      height: 312,
      viewBox: "0 0 auto 310",
      backgroundColor: "#f3f3f3",
      foregroundColor: "#ecebeb",
      style: {
        background: 'white',
        marginTop: '24px'
      }
    }, /*#__PURE__*/React.createElement("rect", {
      x: "208",
      y: "150",
      rx: "3",
      ry: "3",
      width: "250",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "208",
      y: "180",
      rx: "3",
      ry: "3",
      width: "206",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "483",
      y: "150",
      rx: "3",
      ry: "3",
      width: "280",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "483",
      y: "180",
      rx: "3",
      ry: "3",
      width: "206",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "80",
      rx: "3",
      ry: "3",
      width: "1100",
      height: "8"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "100",
      cy: "207",
      r: "80"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "481",
      y: "373",
      rx: "0",
      ry: "0",
      width: "1",
      height: "0"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "483",
      y: "216",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "483",
      y: "240",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "608",
      y: "215",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "608",
      y: "242",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "16",
      rx: "3",
      ry: "3",
      width: "127",
      height: "48"
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, skeletons);
};
export default ItemSkeletonDesk;